import {
  IconButton,
  Menu,
  MenuItem,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core"
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline"
import MoreVertIcon from "@material-ui/icons/MoreVert"
import PersonIcon from "@material-ui/icons/Person"
import PropTypes from "prop-types"
import React, { useContext } from "react"
import HoverText from "~/components/Common/HoverText"
import PaperListRow from "~/components/Common/PaperListRow"
import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import AppContext from "~/contexts/App"
import UsersContext from "~/contexts/Users"

import Box from "~/components/Common/Box"
import useStyles from "./styles"

const AdminCard = ({ admin, i }) => {
  const classes = useStyles()
  const theme = useTheme()
  const smScreen = useMediaQuery(theme.breakpoints.down("sm"))

  const { setPermissionsMutation, deleteAdminMutation } =
    useContext(UsersContext)
  const { authUser, openDialog } = useContext(AppContext)
  const adminIsSuper = admin?.permission_group === "super"
  const [anchorEl, setAnchorEl] = React.useState(null)

  //open dialog to delete admin
  const openDeleteConfirmation = () => {
    let data = {
      title: "Delete Admin",
      subtitle: "",
      type: "admin",
      delete: deleteAdminMutation,
      id: admin.id,
      confirmWord: "delete",
    }
    openDialog("confirmationTypingDialog", data)
    handleClose()
  }

  const handleOpenPermissions = () => {
    openDialog("permissionsDialog", {
      admin,
      setPermissionsMutation,
    })
    handleClose()
  }

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <Box marginBottom="16px">
      <PaperListRow
        key={i}
        componentWidth="100%"
        componentHeight={smScreen ? "90px" : "64px"}
      >
        {smScreen ? (
          <Box display="flex" alignItems="center" className={classes.nameText}>
            <span className={classes.labelSpan}>Name:&nbsp;&nbsp;</span>
            <HoverText data={admin.name} size={100} variant={"subtitle1"} />
          </Box>
        ) : (
          <Box display="flex" alignItems="center" className={classes.nameText}>
            <HoverText data={admin.name} size={100} variant={"subtitle1"} />
          </Box>
        )}
        {smScreen ? (
          <Box className={classes.emailText}>
            <span className={classes.labelSpan}>Email:&nbsp;&nbsp;</span>
            <HoverText data={admin.email} size={100} variant={"subtitle1"} />
          </Box>
        ) : (
          <Box className={classes.emailText}>
            <HoverText data={admin.email} size={100} variant={"subtitle1"} />
          </Box>
        )}
        {smScreen ? (
          <Box className={classes.statusText}>
            <span className={classes.labelSpan}>Status:&nbsp;&nbsp;</span>
            <Typography variant="subtitle1">{admin.status}</Typography>
          </Box>
        ) : (
          <Box className={classes.statusText}>
            <Typography variant="subtitle1">{admin.status}</Typography>
          </Box>
        )}
        {smScreen ? (
          <Box className={classes.statusText}>
            <span className={classes.labelSpan}>Group:&nbsp;&nbsp;</span>
            <Typography variant="subtitle1">
              {admin.permission_group}
            </Typography>
          </Box>
        ) : (
          <Box className={classes.statusText}>
            <Typography variant="subtitle1">
              {admin.permission_group}
            </Typography>
          </Box>
        )}

        <Box width="15%" display="flex" justifyContent="flex-end">
          <PermissionsWrapper permissionGroup="super">
            <>
              <IconButton onClick={handleOpenMenu}>
                <MoreVertIcon color="primary" />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={handleOpenPermissions}>
                  <PersonIcon
                    fontSize="inherit"
                    style={{ fontSize: "16px", marginRight: "4px" }}
                  />
                  <Typography>Edit Permissions</Typography>
                </MenuItem>
                {!adminIsSuper ? (
                  <MenuItem onClick={openDeleteConfirmation}>
                    <DeleteOutlineIcon
                      fontSize="inherit"
                      color="inherit"
                      style={{
                        fontSize: "16px",
                        marginRight: "4px",
                        color: "#FF5E69",
                      }}
                    />
                    <Typography color="inherit" style={{ color: "#FF5E69" }}>
                      Remove
                    </Typography>
                  </MenuItem>
                ) : null}
              </Menu>
            </>
          </PermissionsWrapper>
        </Box>
      </PaperListRow>
    </Box>
  )
}

AdminCard.propTypes = {
  admin: PropTypes.object,
  i: PropTypes.string,
}

export default AdminCard
